import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

export default async function deletePurchaseStory(purchaseId, storyId) {
    const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/api/v1/purchases/${encodeURIComponent(purchaseId)}/stories/${encodeURIComponent(storyId)}`,
        { headers: { Authorization: `Bearer ${cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)}` } }
    );
    const status = response.data?.status;
    if (status?.code != null && String(status.code) !== '10200') {
        const error = new Error(status.message || 'Unable to delete story.');
        error.response = response;
        throw error;
    }
    return response;
}
